import { Checkbox, FormControlLabel } from '@mui/material';
import { BooleanField } from 'interfaces/genericFields';
import React from 'react';
import { HeaderCellEditorProps } from '.';

const HeaderCheckboxInput = <R, V, Context extends {} = {}>({
  onChange,
  value,
  field,
}: HeaderCellEditorProps<R, V, Context, BooleanField>) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={Boolean(value)}
          onChange={handleChange}
          size="small"
          onBlur={(e) => {
            e.stopPropagation();
          }}
        />
      }
      label={field?.label}
    />
  );
};

export default HeaderCheckboxInput;
